import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import classNames from 'classnames';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { STEPS, NOTECARD_STEPS } from '../../../redux/mockup-manager/mockup-manager.constants';
import { BeforeApprovingMockup } from './components/before-approving-mockup';
import { ApproveMockup } from './components/approve-mockup';
import { LogoUploadStep } from './components/logo-upload-step';
import { TextEditorStep } from './components/text-editor-step';
import classes from './mockup-manager-popup.scss';
import { NotecardMobileMessage } from './components/notecard-mobile-message';
const renderContent = ({
  currentStep,
  isMobileView
}) => {
  if (NOTECARD_STEPS.includes(currentStep) && isMobileView) {
    return /*#__PURE__*/React.createElement(NotecardMobileMessage, null);
  }
  const STEP_TO_CONTENT_COMPONENT = {
    [STEPS.BEFORE_APPROVING_MOCKUP]: /*#__PURE__*/React.createElement(BeforeApprovingMockup, null),
    [STEPS.APPROVE_MOCKUP]: /*#__PURE__*/React.createElement(ApproveMockup, null),
    [STEPS.NOTECARD_LOGO_AND_COLOR]: /*#__PURE__*/React.createElement(LogoUploadStep, null),
    [STEPS.NOTECARD_TEXT_CONTENT]: /*#__PURE__*/React.createElement(TextEditorStep, null)
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.animatedContent)
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: currentStep,
    timeout: 200
  }, STEP_TO_CONTENT_COMPONENT[currentStep])));
};
const animationClasses = {
  enter: classes.enter,
  enterActive: classes.enterActive,
  exit: classes.exit,
  exitActive: classes.exitActive
};
const titleClasses = {
  root: classes.titleClass
};
export const MockupManagerPopup = ({
  currentStep,
  onClose
}) => {
  const isMobileView = isMobile();
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: true,
    dataPopup: "ApproveMockup",
    content: renderContent({
      currentStep,
      isMobileView
    }),
    classes: {
      paper: classNames(classes.paperClass, NOTECARD_STEPS.includes(currentStep) && classes.paperClassWide)
    },
    popupClassName: classes.dialogClass,
    titleClasses: titleClasses,
    contentClass: classNames(classes.contentClass, NOTECARD_STEPS.includes(currentStep) && classes.contentClassWide),
    closeClass: classes.closeClass,
    onClose: onClose
  });
};